const unitTags = [
  '120V Power',
  '208V Power',
  '240V Power',
  '480V Power',
  '3 Phase Power',
  'Multiple Outlets',
  'Office in Unit',
  'Vehicles Permitted',
  'Window',
  'Fully Enclosed',
  'Water',
  'Drainage',
  'Private Drive-In',
  'Ventilation',
  'Private Dock',
  'HVAC',
  'Private Exterior Entry',
  'Private Bathroom',
  'Stair-Only Access',
  'Elevator Access',
  'No Forklift Access',
  'Single Door',
  'Next to Dock',
  'Next to Drive In',
  'Multiple Doors',
  'Fire Riser',
  'Electrical Panel',
  'Low Ceiling',
].sort();

export const officeTags = [
  'No HVAC',
  'Window',
  'Water',
  'Private Bathroom',
  'Elevator Access',
  'Stair Access',
  'In Warehouse',
  'Private Exterior Entry',
  'Multiple Outlets',
  'Whse Reqd',
  'Main Level',
  'Upper Level',
].sort();

export const parkingTags = [
  'Covered',
  'Gated',
].sort();

export default unitTags;



// WEBPACK FOOTER //
// ./src/utils/unitTags.js